import React from "react";
import { Link } from "gatsby";
import styled from "@emotion/styled";
import { useColorMode } from "theme-ui";

import Image from "@components/Image";
import { IAuthor } from "@types";

const Bio: React.FC<IAuthor> = ({ author }) => {
  const [colorMode] = useColorMode();

  const isDark = colorMode === "dark";

  return (
    <BioContainer>
      <BioAvatar
        as={author.authorsPage ? Link : "div"}
        to={author.slug}
        data-a11y="false"
        aria-label="Author's bio"
      >
        <BioAvatarInner>
          <Image src={author.avatar.medium} />
        </BioAvatarInner>
      </BioAvatar>
      <BioText isDark={isDark}>
        <Link to="/about">Hassan Djirdeh</Link>'s Personal Blog
      </BioText>
      <SubscribeLinkContainer isDark={isDark}>
        <Link to="/subscribe">Subscribe</Link>
      </SubscribeLinkContainer>
    </BioContainer>
  );
};

export default Bio;

const BioContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  left: -10px;
  width: 100%;
`;

const BioAvatar = styled.div`
  display: block;
  position: relative;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.25);
  margin-right: 16px;
  margin: 10px 26px 10px 10px;
  &::after {
    content: "";
    position: absolute;
    left: -5px;
    top: -5px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.25);
  }
  &[data-a11y="true"]:focus::after {
    content: "";
    position: absolute;
    left: -5px;
    top: -5px;
    width: 50px;
    height: 50px;
    border: 2px solid ${(p) => p.theme.colors.accent};
  }
`;

const BioAvatarInner = styled.div`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.25);
  margin-right: 16px;
  overflow: hidden;
`;

const BioText = styled.p<{ isDark: boolean }>`
  max-width: 430px;
  font-size: 16px;
  line-height: 1.45;
  color: ${(p) => (p.isDark ? "#FFF" : p.theme.colors.grey)};
  a {
    color: ${(p) => p.theme.colors.accent};
    text-decoration: underline;
    font-weight: 600;
  }
`;

const SubscribeLinkContainer = styled.div<{ isDark: boolean }>`
  display: block;
  margin-left: auto;

  a {
    color: ${(p) => p.theme.colors.accent};
    text-decoration: none;
    font-weight: 600;
  }

  svg {
    position: relative;
    bottom: 1px;
  }
`;
